import { TripStepTypeEnum } from '../../lib/types/enums/trip-bookings/trip-step-type.enum'
import { CenterTripInfo, CenterTripInfoKeys } from '../../lib/types/models/trip/trip'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type CenterTripInfoFilters = {
  directionalities: TripStepTypeEnum[]
}

export function getCenterTripInfo<T extends CenterTripInfoKeys[]>(
  id: number,
  tripId: number,
  keys: T,
  filters?: CenterTripInfoFilters
) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.centers.getCenterTripInfo.url, { id, tripId }), {
        keys,
        ...filters
      })
    )
    .get<Pick<CenterTripInfo, T[number]>>()
}
